import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { relativePaths } from '@app/constants';
import _ from 'lodash';
import { OwlOptions } from 'ngx-owl-carousel-o';
import config from '@config/index';
import { getProfilePhotoUrl } from '@app/utils';

@Component({
  selector: 'app-landing-featured-anglers',
  templateUrl: './featured-anglers.component.html',
  styleUrls: ['./featured-anglers.component.scss'],
})
export class FeaturedAnglersComponent implements OnInit {
  @Input() users: any[];
  customOptions: OwlOptions = {
    autoWidth: false,
    items: this.handleNumerItemOfSlider(),
    dotsSpeed: 500,
    dots: true,
    smartSpeed: 400,
    dragEndSpeed: 350,
    nav: false,
    freeDrag: true,
    dotsEach: config.numberOfSliderItem,
  };

  constructor(private router: Router) {}

  ngOnInit() {}

  navigateSignup() {
    this.router.navigate([relativePaths.SIGN_UP]);
  }

  handleNumerItemOfSlider() {
    if (window.innerWidth > 800) {
      return 4;
    } else if (window.innerWidth > 600) {
      return 3;
    } else {
      return 2;
    }
  }

  getProfilePhotoUrl = (user) => getProfilePhotoUrl(user.Id, user.ProfilePhoto, 300);
}
